import { MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import {FacilityProgram} from './FacilityProgram';

export const GeneralConstant = {
  TOKEN: 'Authorization',
  REFRESH_TOKEN: 'refreshToken',
  PERMISSIONS: 'Permissions',
  SKIP_TOKEN: 'X_SKIP_TOKEN',
  DEFAULT_THEME: 'core-theme',
  GROUPS: 'Groups',

  SNACKBAR_DURATION: 8000,
  SNACKBAR_H_POSITION: 'right' as MatSnackBarHorizontalPosition,
  SNACKBAR_V_POSITION: 'top' as MatSnackBarVerticalPosition,
  SNACKBAR_ERROR_CLASS: 'g-snack-error',
  SNACKBAR_RES_ERROR_CLASS: 'g-snackbar-error',
  SNACKBAR_RES_SUCCESS_CLASS: 'g-snackbar-success',
  SNACKBAR_RES_WARNING_CLASS: 'g-snackbar-warning',
  ACCEPTED_PROFILE_IMAGE_FILES: '.jpg, .svg, .png',
  ACCEPTED_ACCREDITATION_FILES: '.jpg, .jpeg, .png, .svg, .xlsx, .pptx, .docx, .xls., .ppt, .doc, .pdf',
  ACCEPTED_INVESTIGATION_FILES: '.jpg, .jpeg, .png, .svg, .m4a, .mp3", .txt, .csv, .xlsx, .pptx, .docx, .xls., .ppt, .doc, .pdf',
  ACCEPTED_DEFICIENCY_FILES: '.jpg, .jpeg, .png, .svg, .m4a, .mp3',
  ACCEPTED_CERTIFICATE_FILE: '.doc, .docx',
  ACCEPTED_APPROVAL_REQUEST_FILE: '.jpg, .jpeg, .png, .svg, .xlsx, .pptx, .docx, .xls., .ppt, .doc, .pdf',

  MEDSPA_RED_NOT_ALLOWED: 'Not Allowed-Click on Find out my Class',

  // regexes
  PASSWORD_REGEX_VALIDATOR: /^(?=.*[A-Za-z])(?=.*\d)[\w~@#$%^&*+=`|{}:;!.?\"()\[\]-]{8,}$/,
  PHONE_REGEX_VALIDATOR: /^[+\s\.\/\d]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\.\/\d]*$/,
  WEBSITE_REGEX_VALIDATOR: /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/,
  DATE_REGEX_VALIDATOR: /[0-9]{2}[/][0-9]{2}[/][0-9]{4}/,
  DATE_FORMAT: 'MM/dd/yyyy',
  DATE_FORMAT_NO_LEADING_ZEROS: 'M/d/y',
  DATE_TIME_FORMAT: 'MM/dd/yyyy HH:mm',
  JPA_DATE_FORMAT: 'yyyy-MM-dd\'T\'HH:mm:ss.SSS\'Z\'',
  JPA_SHORT_DATE_FORMAT: 'yyyy-MM-dd',
  NUMBER_REGEX_VALIDATOR: '^[+]?([0-9]+(?:[\\.][0-9]*)?|\\.[0-9]+)$',
  EMAIL_REGEX_VALIDATOR: '^([A-Za-z0-9._%+\'-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,10})?$',
  NAME_REGEX_VALIDATOR: /^([A-Za-z]|\s|-|'|\.)+$/,
  USERNAME_REGEX_VALIDATOR: /^([A-Za-z\d]|-|_|\.)+$/,
  ZIP_REGEX_VALIDATOR: /^([A-Za-z\d]|\s|-|\.)+$/,
  LEGAL_BUSINESS_NAME_REGEX_VALIDATOR: /^([A-Za-z\d]|\s|-|_|'|,|&|\.)+$/,
  ALTERNATE_FACILITY_NAME_REGEX_VALIDATOR: /^([A-Za-z]|\s|-|_|\$|%|'|"|@|~|!|=|\[|\]|&|#|\+|\,|\.)+$/,
  ALPHANUMERIC_AND_SYMBOL_REGEX_VALIDATOR: /^([A-Za-z\d]|\s|-|_|\$|%|'|"|@|~|!|=|\[|\]|&|#|\+|\,|\.)+$/,
  BUSINESS_HOURS_REGEX_VALIDATOR: /^(\d|\s|-|\.)*$/,
  HOURS_PER_WEEK_REGEX_VALIDATOR: /^(\d|-|\.)*$/,
  POSITIVE_INTEGER_REGEX_VALIDATOR: /^\d*$/,
  DECIMAL_NUMBER_REGEX_VALIDATOR: /^\d*\.?\d*$/,
  FACILITY_NAME_REGEX_VALIDATOR: /^([A-Za-z\d]|\s|-|_|\$|'|"\[|\]|&|\+|\,|\.)+$/,
  DOING_BUSINESS_AS_SYMBOL_REGEX_VALIDATOR: /^[A-Za-z0-9' -+\.,&!"”#$%&'()*+,-./\\:;@{}[?\]~_^`|]*$/,
  NUMBER_INPUT_VALIDATOR: /^[0-9]+$/,
  CITY_REGEX_VALIDATOR: /^[a-zA-Z-'_()&,. ]+$/,
  FACILITY_URL_REGEX_VALIDATOR: /^(https?:\/\/)?(www\.)?([\da-zA-Z\.-]+)\.([a-zA-Z\.]{2,6})([\/\w \.-]*)*\/?$/,
  PROGRAMS_WITHOUT_PATIENT_TRANSFER: [FacilityProgram.MEDICARE_PHYSICAL_THERAPY, FacilityProgram.MEDICARE_RURAL_HEALTH, FacilityProgram.INTERNATIONAL_PHYSICAL_THERAPY]
};
